/**
 * Normalización de texto para búsquedas
 * -----------------------------------------------------------------------------
 * Sin tildes y en minúsculas: nadie escribe «México», «Perú» ni «Fertilización»
 * con tilde en un buscador.
 */
export function normalizeText(text) {
  return String(text == null ? '' : text)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

export default normalizeText;
